import * as React from 'react'
import { Select, Checkbox, message, Icon, Tooltip } from 'antd'
import { API, IBatchResponse } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../utilities/helpers'

interface IProps {
  wrapperClassName?: string
  productId: string
  companyId: number
  locationId: number
  onSelect: (batchId: number | undefined) => void
  selectedBatchId?: number
}

interface IState {
  isLoading: boolean
  excludeClosed: boolean
  batches: IBatchResponse[]
}

export class AvailableBatchSelect extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      isLoading: false,
      excludeClosed: true,
      batches: [],
    }
  }

  componentDidMount = async () => this.loadBatches()

  onCheckboxChange = async () => {
    await this.setState({ excludeClosed: !this.state.excludeClosed })
    await this.loadBatches()
  }

  loadBatches = async () => {
    const { companyId, locationId, productId } = this.props
    const { excludeClosed } = this.state

    try {
      this.setState({ isLoading: true })
      const batches = await API.getAvailableBatches(companyId, locationId, productId, excludeClosed)
      this.setState({ batches, isLoading: false })
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while loading lots')
    }
  }

  render() {
    const { isLoading, batches, excludeClosed } = this.state
    const { wrapperClassName, onSelect, selectedBatchId } = this.props

    return (
      <div className={wrapperClassName}>
        <Select
          style={{ width: 200 }}
          dropdownMatchSelectWidth={false}
          value={selectedBatchId}
          loading={isLoading}
          allowClear
          placeholder='Select lot #'
          onChange={(value: any) => onSelect(value ? (value as number) : undefined)}
        >
          {batches.map((b, index) => {
            return (
              <Select.Option key={index} value={b.id}>
                {`${b.batchNumber}, ${b.quantityRemaining} units remaining`}
              </Select.Option>
            )
          })}
        </Select>

        <Checkbox className='ml-2' checked={excludeClosed} onChange={this.onCheckboxChange}>
          <span className='mr-2'>Exclude closed</span>

          <Tooltip title='Exclude lots that have been closed. These are lots that have been audited to 0.'>
            <Icon type='question-circle' />
          </Tooltip>
        </Checkbox>
      </div>
    )
  }
}
